import Color from 'color'

export const Opacities = {
  medium: 0.7
}

export const opacity = (base: string, value: number) => Color(base).alpha(value).rgb().toString()
